import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { saveAddtionalPage } from '@/redux/actions';
import { getThemeComponent } from '@/utils/themeImports';
import { useRouter } from 'next/router';
import { specificThemeRender } from '@/utils/specificThemeRender';
import { useSSRSelector } from '../../redux';

const BlogPage = (props) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const imageRef = useRef(null);
  const { id } = router.query;
  const { list } = props?._addPage?.json_data?.blog?.users_list;

  const { storeInfo, catalogCategories, widgetsData } = useSSRSelector((state) => ({
    storeInfo: state.storeReducer.store,
    catalogCategories: state.catalogReducer.categories,
    widgetsData: state.jsonWidgetsReducer.widgets,
  }));
  const isNewBlogWidget = Object.values(widgetsData)?.find(
    (data) => data?.name === 'NewBlog'
  );
  const [blogData, setBlogData] = useState({});

  useEffect(() => {
    if (props?._addPage) {
      dispatch(saveAddtionalPage(props._addPage));
    }
  }, []);

  useEffect(() => {
    if (id && list?.length) {
      const listItem = list[id];
      if (listItem && Object.keys(listItem).length) {
        setBlogData(listItem);
      }
    }
  }, [id, list]);

  function renderNewBlogWidgetComp() {
    return (
      <div className="tw-m-auto tw-mb-[150px] tw-max-w-[1000px]">
        <div className="tw-mb-[46px] tw-mt-[40px] tw-flex tw-flex-col tw-gap-[16px]">
          <img
            ref={imageRef}
            src={blogData?.image?.url}
            alt={blogData?.image?.display_text}
            className="tw-mb-[32px] tw-max-h-[500px] tw-object-contain"
          />
          <div className="tw-m-auto tw-w-[640px] tw-text-[12px] tw-font-normal tw-text-[#555D70]">
            <span className="">
              {blogData?.date?.selected_date + ' ' + blogData?.date?.selected_month}
            </span>
          </div>
          <div className="tw-m-auto tw-w-[640px] tw-text-[32px] tw-font-[600] tw-text-[#000]">
            {blogData?.heading?.display_text}
          </div>
        </div>
        <div
          style={{ borderBottom: '1px solid #111C3633' }}
          className="tw-mb-[40px]"
        ></div>
        <div className="tw-w-[100%] tw-text-[16px] tw-font-normal tw-leading-[1.7] tw-text-[#242424]">
          <div className="tw-m-auto tw-w-[640px]">
            {blogData?.description?.display_text}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {specificThemeRender(storeInfo)?.components?.Header?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, {
          storeData: props.storeInfo,
          categories: catalogCategories || [],
          ...layout,
        });
      })}
      {!isNewBlogWidget
        ? Object.keys(blogData).length > 0 && (
            <main className="blogPage-main">
              <section className="blogPage-main__image relative mb5">
                <img
                  src={blogData?.image?.url}
                  alt={blogData?.image?.display_text}
                  className="w-100"
                />
                <div className="date-box f5 flex flex-column justify-center items-center">
                  <p className="f3 fw6 mv0">{blogData?.date?.selected_date}</p>
                  <p className="f6 mv0">{blogData?.date?.selected_month}</p>
                </div>
              </section>
              <section className="mv4 blogPage-main__body">
                <h3>{blogData?.heading?.display_text}</h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: blogData?.description?.display_text,
                  }}
                />
              </section>
            </main>
          )
        : renderNewBlogWidgetComp()}

      {specificThemeRender(storeInfo)?.components?.Footer?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, {
          storeData: storeInfo,
          categories: catalogCategories || [],
          ...layout,
        });
      })}
    </div>
  );
};

export default BlogPage;
